module.exports = __webpack_public_path__ + "static/img/NoInformation.1259d1ad.png";